import { useContext } from 'react'
import { FpB2bProductCatalogContext } from '../components/ProductCatalogProvider/ProductCatalogProvider'

export function useProductCatalog() {
  const context = useContext(FpB2bProductCatalogContext)

  if (!context) throw new Error('useProductCatalog must be used within <FpB2bProductCatalogProvider>')

  return context
}
